// extracted by mini-css-extract-plugin
module.exports = {"app":"_2JMNg","overlay":"_1sq_G"};